import { useCallback } from 'react';
import debounce from 'lodash/debounce';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDebounce = <T extends (...args: any[]) => void>(callback: T, delay: number) =>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useCallback(debounce(callback, delay), [callback, delay]);
